import type { AxiosResponse } from 'axios'

export type WrappedResponse<T> = [
  data: T | null,
  status: number,
  error: any | null
]

export default async function wrapCall<T = any>(
  promise: Promise<AxiosResponse<T>>
): Promise<WrappedResponse<T>> {
  try {
    const response = await promise
    return [response.data, response.status, null]
  } catch (error: any) {
    return [null, error?.response?.status ?? 0, error]
  }
}

export { wrapCall }
